export const CovidTestGuestFooter_translations = {
  en: {
    covidInfo: 'For technical assistance:',
    CovidPatientSelectHelpline: '385-297-6430',
    CovidHelplineHours: '(M-F 7am-8pm, Sat 9am-2pm, Closed Sunday)'
  },
  es: {
    covidInfo: 'Si necesita ayuda o tiene preguntas técnicas, llame al: ',
    CovidPatientSelectHelpline: '385-297-6430',
    CovidHelplineHours:
      '(De lunes a viernes de 7 a 20 horas, sábado de 9 a 14 horas, domingo cerrado)'
  }
};

export const ButtonsNavigation_translations = {
  en: {
    next: 'Next',
    cancel: 'Cancel',
    submit: 'Submit',
    previous: 'Previous',
    skip: 'Skip',
    close: 'Close',
    resend: 'RESEND',
    verify: 'Verify',
    continue: 'Continue'
  },
  es: {
    next: 'Siguiente',
    cancel: 'Cancelar',
    submit: 'Enviar',
    previous: 'Anterior',
    skip: 'Saltar',
    close: 'Cerrar',
    resend: 'REENVIAR',
    verify: 'Verificar',
    continue: 'Continuar'
  }
};

export const ExitPopUp_translations = {
  en: {
    title: 'Are you sure you want to exit?',
    subtitle: 'Your information will be lost.',
    primaryButton: `Exit COVID screening`,
    secondaryButton: 'Continue Screening'
  },
  es: {
    title: '¿Seguro qué quiere salir?',
    subtitle: 'Se perderá su información.',
    primaryButton: `Salir del sitio de pruebas COVID`,
    secondaryButton: 'Continuar en el sitio'
  }
};

export const yesNotranslations = {
  en: {
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown'
  },
  es: {
    yes: 'Sí',
    no: 'No',
    unknown: 'No sé'
  }
};

export const relationTranslations = {
  en: {
    self: 'Self',
    spouse: 'Spouse',
    child: 'Child',
    stepchild: 'Stepchild',
    grandchild: 'Grandchild',
    lifePartner: 'Life Partner',
    overageDependent: 'Overage Dependent',
    other: 'Other'
  },
  es: {
    self: 'Yo mismo/a',
    spouse: 'Cónyuge',
    child: '	Hijo/a',
    stepchild: 'Hijastro/a',
    grandchild: 'Nieto/a',
    lifePartner: 'Pareja',
    overageDependent: 'Dependiente mayor de edad',
    other: 'Otro'
  }
};

export const genderTranslations = {
  en: {
    male: 'Male',
    female: 'Female',
    both: 'Both',
    unknown: 'Unknown'
  },
  es: {
    male: 'Masculino',
    female: 'Femenino',
    both: 'Ambos',
    unknown: 'No sé'
  }
};

export const ExpandedView = {
  en: {
    Dashboard: 'Dashboard',
    HealthRecordsHome: 'Health Record',
    GetCareHomeScreen: 'Get Care',
    MessageHomeScreen: 'Messages',
    BillingHomeScreen: 'Billing',
    HealthTools: 'Health Tools',
    Wellness: 'Wellness',
    MH: 'My Health',
    FHH: 'Family Health History',
    SH: 'SelectHealth',
    help: 'Help',
    language: 'Language',
    GuestAccount: 'Guest Account',
    SwitchPerson: 'Switch Person',
    RecordSearch: 'Record Search',
    RefreshUserList: 'Refresh user list',
    AccountManagement: 'Account Management',
    HelpCenter: 'Help Center',
    SignOut: 'Sign Out'
  },
  es: {
    Dashboard: 'Inicio',
    HealthRecordsHome: 'Registro de salud',
    GetCareHomeScreen: 'Obtener atención',
    MessageHomeScreen: 'Mensajes',
    BillingHomeScreen: 'Facturación',
    HealthTools: 'Herramientas de salud',
    Wellness: 'Bienestar',
    MH: 'My Health',
    FHH: 'Historial Medico Familiar',
    SH: 'SelectHealth',
    help: 'Ayuda',
    language: 'Idioma',
    GuestAccount: 'Cuenta de invitado',
    SwitchPerson: 'Cambiar usuario',
    RecordSearch: 'Buscar registros',
    RefreshUserList: 'Actualizar lista de usuarios',
    AccountManagement: 'Administración de cuentas',
    HelpCenter: 'Centro de ayuda',
    SignOut: 'Cerrar sesión'
  }
};

export const crumbLabels = {
  en: {
    GuestHome: 'Guest Home',
    CovidGuestTitle: 'Covid-19 Test Screening'
  },
  es: {
    GuestHome: 'Pantalla de Invitado',
    CovidGuestTitle: 'Prueba de detección de Covid-19'
  }
};
